import useWindowSize from "hooks/useWindowSize"
import * as S from "./CnpHoldingVideos.style"

const CnpHoldingVideos = () => {
    const { width } = useWindowSize()
    return (
        <S.SectionCnpHoldingVideo>
            <S.ContainerCnpHoldingVideo>
                <S.ContentCnpHoldingVideo>
                    <S.TitleCnpHoldingVideo>
                        Manifesto
                    </S.TitleCnpHoldingVideo>
                    <S.ParagraphCnpHoldingVideo>
                        Somos motivados pela vocação cidadã do nosso grupo, que nos orgulha e é a base das nossas decisões e ações, norteadas por práticas sociais, ambientais e de governança. É assim que colaboramos para a construção de um mundo melhor para as próximas gerações.
                        Quer saber como fazemos isso? Então <strong>dê o play e confira o nosso manifesto!</strong>
                    </S.ParagraphCnpHoldingVideo>
                </S.ContentCnpHoldingVideo>
                {width > 768
                    ?
                    <iframe
                        title="Youtube"
                        width="756"
                        height="426"
                        src="https://www.youtube.com/embed/CIk4izorEoY"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    >
                    </iframe>
                    :
                    <iframe
                        title="Youtube"
                        width="336"
                        height="186"
                        src="https://www.youtube.com/embed/CIk4izorEoY"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    >
                    </iframe>
                }
            </S.ContainerCnpHoldingVideo>
        </S.SectionCnpHoldingVideo>
    )
}

export default CnpHoldingVideos